import { memo } from 'react';
import { useUserData } from 'root/src/client/v2/userData/hooks/useUserData';
import { resolveLinkMarketingCopy } from 'root/src/shared/util/resolveLinkMarketingCopy';
// Redesign counterpart of the legacy ChatMessagePreview (common/components/ChatMessagePreview):
// renders the Twitch announcement exactly as it will appear in the creator's chat.
export const RedesignChatMessagePreview = memo(({ linkMarketingCopy, url }) => {
    var _a, _b;
    const { userData } = useUserData();
    const displayName = (_b = (_a = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : 'You';
    const message = resolveLinkMarketingCopy(linkMarketingCopy, url);
    const parts = message.split(/(https?:\/\/\S+)/g);
    return (<div className="w-full rounded-lg border border-solid border-white/[0.06] bg-black/20 p-3">
			<p className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">Chat preview</p>
			<div className="overflow-hidden rounded border border-l-[3px] border-solid border-[#a970ff]/40 border-l-[#a970ff] bg-[#a970ff]/[0.06]">
				<div className="flex items-center gap-1.5 px-2 py-1.5">
					<svg width="14" height="14" viewBox="0 0 24 24" fill="#a970ff" aria-hidden>
						<path fillRule="evenodd" clipRule="evenodd" d="m13 17 9 5V2l-9 5H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h3v5h2v-5h4Zm7-11.601-6 3.333v6.536l6 3.333V5.399ZM4 9h8v6H4V9Z"/>
					</svg>
					<span className="text-xs font-semibold text-[#a970ff]">Announcement</span>
				</div>
				<div className="flex flex-wrap items-start gap-1.5 px-2 pb-2">
					<span className="text-sm font-bold text-neon-cyan">{displayName}</span>
					<span className="break-all text-sm text-foreground/90">
						{parts.map(part => (/^https?:\/\//.test(part)
            ? <a key={part} href={part} target="_blank" rel="noopener noreferrer" className="text-[#a970ff] underline">{part}</a>
            : <span key={part}>{part}</span>))}
					</span>
				</div>
			</div>
		</div>);
});
